import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Button,
} from '@mui/material';
import { Edit, Add } from '@mui/icons-material';
import { beginEditingOrg, beginNewOrg } from '../../../redux/actions/users';

import './orgs-table.css';

const OrgsTable = ({
  organizations,
  beginEditing,
  newOrganization,
  editType,
  editingId,
  scrollTop,
}) => (
  <div className="orgs-table">
    <div className="new-org">
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          scrollTop();
          newOrganization();
        }}
      >
        <Add />
        Create new Organization
      </Button>
    </div>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Edit</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Short Name</TableCell>
          <TableCell>Abbreviation</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {organizations.map((org) => (
          <TableRow
            className="orgs-row"
            key={org.id}
            hover
            selected={editType === 'ORG' && editingId === org.id}
            classes={{ selected: 'active' }}
          >
            <TableCell>
              <IconButton
                onClick={() => {
                  scrollTop();
                  beginEditing(org.id);
                }}
                size="large"
              >
                <Edit />
              </IconButton>
            </TableCell>
            <TableCell>{org.name}</TableCell>
            <TableCell>{org.short_name}</TableCell>
            <TableCell>{org.name_abbr}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default connect(
  ({
    users: {
      organizations,
      editing: { editType, id },
    },
  }) => ({
    organizations,
    editType,
    editingId: id,
  }),
  (dispatch) => ({
    beginEditing: (id) => dispatch(beginEditingOrg(id)),
    newOrganization: () => dispatch(beginNewOrg()),
  })
)(OrgsTable);
